import { render, staticRenderFns } from "./CanvasOptBar.vue?vue&type=template&id=a34bf15c&scoped=true&"
import script from "./CanvasOptBar.vue?vue&type=script&lang=js&"
export * from "./CanvasOptBar.vue?vue&type=script&lang=js&"
import style0 from "./CanvasOptBar.vue?vue&type=style&index=0&id=a34bf15c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a34bf15c",
  null
  
)

export default component.exports